<template>
  <div>
    <section class="section is-main-section">
      <h1 class="title">
        {{ title }}
        <b-button
          @click="add()"
          class="is-primary is-pulled-right"
          icon-left="plus"
        >
          ເພີ່ມໃໝ່
        </b-button>
      </h1>
      <card-component class="has-table has-mobile-sort-spaced">
        <b-table
          :loading="isLoading"
          :paginated="paginated"
          :per-page="perPage"
          :striped="true"
          :hoverable="true"
          :data="models"
        >
          <b-table-column label="#" v-slot="props">
            {{ props.index + 1 }}
          </b-table-column>
          <b-table-column label="ຊື່ແຂວງ" field="name" sortable v-slot="props">
            {{ props.row.name }}
          </b-table-column>
          <b-table-column
            custom-key="actions"
            cell-class="is-actions-cell"
            v-slot="props"
          >
            <div class="buttons is-right">
              <b-button
                class="is-small is-warning"
                @click="edit(props.row)"
                icon-left="pencil"
              >
              </b-button>
              <b-button
                class="is-small is-danger"
                v-if="false"
                icon-left="trash-can"
              >
              </b-button>
            </div>
          </b-table-column>

          <empty-table v-if="models.length == 0" :isLoading="isLoading" />
        </b-table>
      </card-component>
    </section>

    <div class="modal is-active" v-if="isShowModal && model">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ title }}</p>
          <button
            class="delete"
            aria-label="close"
            @click="closeModal()"
          ></button>
        </header>
        <section class="modal-card-body">
          <b-field label="">
            <b-input v-model="model.name" placeholder="ແຂວງ" required />
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <b-button
            class="is-success"
            slot="right"
            @click="save()"
            icon-left="check"
          >
            ບັນທຶກ
          </b-button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import { get } from "vuex-pathify";
import CardComponent from "@/components/CardComponent";
import EmptyTable from "../components/EmptyTable.vue";
const route = "provinces";
export default {
  name: "Province",
  components: { CardComponent, EmptyTable },
  computed: {
    user: get("user"),
  },
  data() {
    return {
      perPage: 20,
      title: "ແຂວງ",
      model: null,
      models: [],
      isShowModal: false,
      isLoading: false,
      url: null,
      paginated: false,
    };
  },
  mounted() {
    console.log("mounted");
    this.get();
  },
  methods: {
    get() {
      this.model = null;
      this.isLoading = true;
      Axios.get(route)
        .then((r) => {
          this.isLoading = false;
          this.models = r;
        })
        .catch((e) => {
          this.isLoading = false;
          console.error(e);
        });
    },
    add() {
      this.model = {};
      this.isShowModal = true;
    },
    edit(item) {
      this.model = item;
      this.isShowModal = true;
    },
    save() {
      let req;
      this.model.user_id = this.user.id;
      if (!this.model.id) {
        req = Axios.put(route, this.model);
      } else {
        req = Axios.post(route, this.model);
      }
      req.then((res) => {
        console.log(res);
        this.get();
      });
    },
    closeModal() {
      this.isShowModal = false;
    },
  },
};
</script>
